import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class Breadcrumb extends Component {
    render (){
        const {title, parent} = this.props;
        return (
            <div className="breadcrumb-section">
                <div className="container">
                    <div className="row">
                       {/*  <div className="col-md-6">
                            <div className="page-title">
                           
                                    <Link to={`${process.env.PUBLIC_URL}`}>Home</Link>
                                    
                               
                            </div>
                        </div> */}
                        <div className="">
                            <nav aria-label="breadcrumb" className="theme-breadcrumb">
                                <div>Home</div>
                               <h2 >{title}</h2>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Breadcrumb;